/**
 * @generated SignedSource<<cd612c439d932484c831e9b1dad9fa74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteBaselineVersionInput = {
  projectId: string;
  baselineVersionId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteBaselineVersionMutation$variables = {
  input: DeleteBaselineVersionInput;
};
export type DeleteBaselineVersionMutation$data = {
  readonly deleteBaselineVersion: {
    readonly deletedBaselineVersionId: string | null;
    readonly project: {
      readonly id: string;
      readonly baselineVersions: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly versionNumber: number | null;
        readonly isActive: boolean | null;
        readonly isStandard: boolean | null;
      }> | null;
    } | null;
  } | null;
};
export type DeleteBaselineVersionMutation = {
  variables: DeleteBaselineVersionMutation$variables;
  response: DeleteBaselineVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteBaselineVersionPayload",
    "kind": "LinkedField",
    "name": "deleteBaselineVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedBaselineVersionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BaselineVersion",
            "kind": "LinkedField",
            "name": "baselineVersions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "versionNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isStandard",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteBaselineVersionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteBaselineVersionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f92549470f9a73df917d0b6aa59c09c9",
    "id": null,
    "metadata": {},
    "name": "DeleteBaselineVersionMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteBaselineVersionMutation(\n  $input: DeleteBaselineVersionInput!\n) {\n  deleteBaselineVersion(input: $input) {\n    deletedBaselineVersionId\n    project {\n      id\n      baselineVersions {\n        id\n        name\n        versionNumber\n        isActive\n        isStandard\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1237ffa91f4df1edc4a4f3a9854b00e";

export default node;
